import { GLAMMATIC_BRAND_IDENTITY } from '../../PublishBanner.constants';
export function getStripeApiKey(brandIdentity) {
  if (brandIdentity === GLAMMATIC_BRAND_IDENTITY) {
    return process.env.STRIPE_GLAMMATIC_API_KEY || process.env.STORYBOOK_STRIPE_API_KEY;
  }
  return process.env.STRIPE_API_KEY || process.env.STORYBOOK_STRIPE_API_KEY;
}